import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/api';
import { useAuth } from '../App';
import { format } from 'date-fns';

const TYPE_LABELS = {
  pack_purchase:       { label: 'Points Pack',     color: 'var(--green)' },
  treatment_debit:     { label: 'Treatment',       color: 'var(--grey-700)' },
  cancellation_refund: { label: 'Refund',          color: 'var(--green)' },
  admin_credit:        { label: 'Credit',          color: 'var(--green)' },
  admin_debit:         { label: 'Adjustment',      color: 'var(--grey-700)' },
  expiry:              { label: 'Expired',         color: 'var(--danger)' },
};

export default function WalletPage() {
  const { session } = useAuth();
  const [wallet, setWallet] = useState({ balance: 0, nextExpiry: null, transactions: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.rpc('get_my_wallet_data')
      .then(({ data }) => {
        if (data) setWallet({
          balance: data.balance || 0,
          transactions: data.transactions || [],
          nextExpiry: data.nextExpiry || null,
        });
      }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading-center"><div className="spinner" /></div>;

  // Hide admin debit adjustments from member view — they're usually test/setup
  // entries without member-meaningful context. Admins can still see all transactions
  // in the admin panel's transactions tab.
  const visibleTransactions = (wallet?.transactions || []).filter(tx => tx.type !== 'admin_debit');

  return (
    <div className="page">
      <h1 className="page-title">Wellness Wallet</h1>

      {/* Balance card */}
      <div style={{ background: '#1A1A1A', borderRadius: 16, padding: 28, marginBottom: 20, textAlign: 'center', color: '#fff' }}>
        <div style={{ fontSize: '0.75rem', fontWeight: 700, color: '#FF6200', letterSpacing: '0.1em', marginBottom: 8 }}>CURRENT BALANCE</div>
        <div style={{ fontSize: '4rem', fontWeight: 900, lineHeight: 1 }}>{wallet?.balance || 0}</div>
        <div style={{ color: '#aaa', marginTop: 4 }}>wellness points</div>
        {wallet?.nextExpiry && (
          <div style={{ background: 'rgba(255,255,255,0.08)', borderRadius: 8, padding: '10px 16px', marginTop: 16, fontSize: '0.85rem', color: '#ccc' }}>
            ⏰ Expires {format(new Date(wallet.nextExpiry), 'd MMMM yyyy')}
          </div>
        )}
        <Link to="/wallet/packs" className="btn btn-primary btn-full" style={{ marginTop: 16 }}>Buy More Points</Link>
      </div>

      {/* Transaction history */}
      <div className="section-title">History</div>
      {visibleTransactions.length === 0 && (
        <div style={{ textAlign: 'center', color: 'var(--grey-500)', padding: 32 }}>No transactions yet</div>
      )}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {visibleTransactions.map((tx, i) => {
          const meta = TYPE_LABELS[tx.type] || { label: tx.type, color: 'var(--grey-700)' };
          const isCredit = tx.points_delta > 0;
          return (
            <div key={tx.id} className="card" style={{ padding: '14px 16px', borderRadius: i === 0 ? '12px 12px 4px 4px' : i === visibleTransactions.length - 1 ? '4px 4px 12px 12px' : 4, boxShadow: 'none', border: '1px solid var(--grey-300)', display: 'flex', alignItems: 'center', gap: 12 }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600, fontSize: '0.9rem' }}>{tx.description || meta.label}</div>
                <div style={{ color: 'var(--grey-500)', fontSize: '0.75rem', marginTop: 2 }}>
                  {format(new Date(tx.created_at), 'd MMM yyyy, h:mm aaa')} · Balance: {tx.balance_after} pts
                </div>
              </div>
              <div style={{ fontWeight: 700, fontSize: '1rem', color: isCredit ? 'var(--green)' : 'var(--black)', flexShrink: 0 }}>
                {isCredit ? '+' : ''}{tx.points_delta}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
